require('./gamesOfTheWeekController');
require('./gameCard/gameCardDirective');

"use strict";

angular.module('app.gamesOfTheWeek', [
    'app.gamesOfTheWeek.gamesOfTheWeekController',
    'app.gamesOfTheWeek.gameCard.gameCardDirective'
])
    .config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('app.gotw', {
                url: '/gotw',
                templateUrl: 'components/gamesOfTheWeek/gamesOfTheWeekView.html',
                controller: 'app.gamesOfTheWeek.gamesOfTheWeekController',
                title: 'Games of the Week'
            });
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/gamesOfTheWeek/gamesOfTheWeek.js